import type { IntegrationFn } from '@sentry/core'
import { logBreadcrumb } from '../sentry'

const getPageLifecycleState = () => {
  return {
    visibilityState: document.visibilityState,
    hasFocus: document.hasFocus?.(),
    // @ts-expect-error not-supported by all browsers
    wasDiscarded: document.wasDiscarded,
  }
}

// based on https://developer.chrome.com/static/docs/web-platform/page-lifecycle-api/image/page-lifecycle-api-state-a8e7c36ceae18.svg
const pageLifecycleIntegration: IntegrationFn = () => ({
  name: 'PageLifecycleIntegration',
  setup: () => {
    const log = (message: string) => {
      logBreadcrumb({
        type: 'debug',
        message: `[Lifecycle] ${message}`,
        level: 'debug',
        category: 'lifecycle',
        data: getPageLifecycleState(),
        timestamp: Date.now() / 1000,
      })
    }

    window.addEventListener('focus', () => log('Page focused'))
    window.addEventListener('blur', () => log('Page blurred'))

    window.addEventListener('resume', () => log('Page resumed'))
    window.addEventListener('freeze', () => log('Page frozen'))

    window.addEventListener('pageshow', () => log('Page shown'))
    window.addEventListener('pagehide', () => log('Page hiding'))

    window.addEventListener('load', () => log('Page loaded'))

    window.addEventListener('visibilitychange', () =>
      log('Page visibility change')
    )
  },
  processEvent: (event) => {
    // eslint-disable-next-line no-param-reassign
    event.extra = {
      ...event.extra,
      pageLifecycle: getPageLifecycleState(),
    }
    return event
  },
})

export { pageLifecycleIntegration }
